export enum SaleTypeEnum {
  RetailSales = 1,
  DirectSales = 2,
  AllOfIt = 3
}
